// src/app/layout/components/main-layout/main-layout.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    SidebarComponent,
    HeaderComponent,  ],
  template: `
  <div class="h-screen flex bg-slate-50 overflow-hidden">
    <!-- Sidebar -->
    <app-sidebar></app-sidebar>
    
    <!-- Main content -->
    <div class="flex-1 flex flex-col min-w-0 overflow-hidden">
      <!-- Header -->
      <app-header></app-header>
      
      <!-- Breadcrumbs -->
<!--       <app-breadcrumb></app-breadcrumb>
 -->      
      <!-- Page content -->
      <main class="flex-1 pl-6 pr-6 pt-6 bg-slate-50 overflow-y-auto">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
`
})
export class MainLayoutComponent { }
